import React from "react";

export function ImgModal({ img }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50" data-testid="img-modal-overlay">
      <div className="bg-white p-4 rounded-lg max-w-4xl max-h-screen overflow-auto" data-testid="img-modal-container">
        <div className="flex justify-end mb-2" data-testid="img-modal-header">
          <button
            onClick={() => window.history.back()}
            className="text-gray-600 hover:text-gray-800"
            data-testid="img-modal-close-button"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
        </div>
        <img
          src={img}
          alt="Modal"
          className="max-w-full max-h-[80vh]"
          data-testid="img-modal-image"
        />
      </div>
    </div>
  );
}
